import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyHerdDetails } from "services";

import { FOOTPRINTING_DAIRY, GET_DAIRY_HERD_DETAILS } from "consts";

import { FootprintingDairyHerdDetails } from "models";

export const useMutateFootprintingDairyHerdDetails = (
  farmId: string,
  year: number,
  payload: Partial<Omit<FootprintingDairyHerdDetails, "id" | "primaryDataId">>,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [GET_DAIRY_HERD_DETAILS, primaryDataId],
    mutationFn: () => setDairyHerdDetails(payload, primaryDataId),
    onSuccess: async () => {
      const QKs = [
        [GET_DAIRY_HERD_DETAILS, primaryDataId],
        [GET_DAIRY_HERD_DETAILS, farmId, year],
        [FOOTPRINTING_DAIRY, farmId, year],
      ];
      await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
    },
  });
};
